var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wallet-page",class:{ 'loading': _vm.isProcessing }},[_c('div',{class:{ 'loading': _vm.isLoadingChart }},[_c('binary-tree-expandable')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }